import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_PLACE_HALAL_STOCK_ORDER_FOR_USER } from "../../../config/api";

export const placeOrderForUser = createAsyncThunk(
  "stocks/placeOrderForUser",
  async ({ data, callback, failed }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_PLACE_HALAL_STOCK_ORDER_FOR_USER,
        data: data,
      });
      toast.success("Order placed for user successfully");
      callback && callback(response?.data?.data);
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed && failed();
      return rejectWithValue(error.message);
    }
  }
);
